/** @generated - do not modify this file. */

// src/schema.ts
import { schema } from "@verdant-web/store";
import cuid from "cuid";
var items = schema.collection({
  name: "item",
  primaryKey: "id",
  fields: {
    id: schema.fields.string({
      default: cuid
    }),
    content: schema.fields.string({
      default: ""
    }),
    done: schema.fields.boolean({
      default: false
    }),
    createdAt: schema.fields.number({
      default: () => Date.now()
    })
  },
  indexes: {
    createdAt: {
      field: "createdAt"
    }
  }
});
var entries = schema.collection({
  name: "entry",
  primaryKey: "date",
  fields: {
    date: {
      type: "string",
      default: () => {
        return (/* @__PURE__ */ new Date()).toDateString();
      }
    },
    mood: {
      type: "string",
      options: ["worst", "worse", "same", "better", "best"]
    }
  },
  indexes: {
    date: {
      type: "number",
      compute: (entry) => new Date(entry.date).getTime()
    }
  }
});
var weather = schema.collection({
  name: "weather",
  primaryKey: "id",
  fields: {
    id: schema.fields.string({
      default: cuid
    }),
    date: schema.fields.string({
      default: ""
    }),
    temperature: schema.fields.string({
      default: ""
    }),
    location: schema.fields.string({
      default: ""
    }),
    createdAt: schema.fields.number({
      default: () => Date.now()
    }),
    planId: schema.fields.string({ default: "" })
  },
  indexes: {
    createdAt: {
      field: "createdAt"
    },
    planId: {
      field: "planId"
    }
  },
  compounds: {
    date_location: {
      of: ["date", "location"]
    },
    planId_date_location: {
      of: ["planId", "date", "location"]
    }
  }
});
var airplane = schema.collection({
  name: "airplane",
  primaryKey: "id",
  fields: {
    id: schema.fields.string({
      default: cuid
    }),
    no: schema.fields.string({
      default: ""
    }),
    counter: schema.fields.string({
      default: ""
    }),
    gate: schema.fields.string({
      default: ""
    }),
    checkedBagKg: schema.fields.string({
      default: ""
    }),
    pnr: schema.fields.string({
      default: ""
    }),
    platform: schema.fields.string({
      default: ""
    }),
    itinerary: schema.fields.string({
      default: ""
    }),
    orderId: schema.fields.string({
      default: ""
    }),
    seats: schema.fields.array({
      items: { "type": "array", items: schema.fields.string() }
    }),
    bagDirect: schema.fields.boolean({
      default: false
    }),
    createdAt: schema.fields.number({
      default: () => Date.now()
    }),
    planId: schema.fields.string({ default: "" })
  },
  indexes: {
    createdAt: {
      field: "createdAt"
    },
    no: {
      field: "no"
    }
  },
  compounds: {
    planId_no: {
      of: ["planId", "no"]
    }
  }
});
var events = schema.collection({
  name: "events",
  primaryKey: "id",
  fields: {
    id: schema.fields.string({
      default: cuid
    }),
    date: schema.fields.string({}),
    type: schema.fields.string({}),
    airplane: schema.fields.object({
      nullable: true,
      properties: {
        no: schema.fields.string({ nullable: true })
      }
    }),
    custom: schema.fields.object({
      default: {},
      properties: {
        title: schema.fields.string({ default: "" }),
        content: schema.fields.string({ default: "" }),
        time: schema.fields.string({ default: "" })
      }
    }),
    orderIdx: schema.fields.number({
      nullable: true
    }),
    cover: schema.fields.string({
      default: ""
    }),
    images: schema.fields.array({
      items: schema.fields.string({
        default: ""
      })
    }),
    createdAt: schema.fields.number({
      default: () => Date.now()
    }),
    planId: schema.fields.string({ default: "" }),
    startTime: schema.fields.string({ default: "" }),
    endTime: schema.fields.string({ default: "" }),
    icon: schema.fields.string({ default: "" }),
    money: schema.fields.string({ default: "" }),
    routeArray: schema.fields.array({
      items: { "type": "array", items: schema.fields.string() }
    }),
    route: schema.fields.string({ default: "" })
  },
  indexes: {
    date: {
      field: "date"
    }
  },
  compounds: {
    planId_date: {
      of: ["planId", "date"]
    }
  }
});
var expense = schema.collection({
  name: "expense",
  primaryKey: "id",
  fields: {
    id: schema.fields.string({
      default: cuid
    }),
    date: schema.fields.string({
      default: ""
    }),
    createdAt: schema.fields.number({
      default: () => Date.now()
    }),
    planId: schema.fields.string(),
    category: schema.fields.string(),
    description: schema.fields.string({ default: "" }),
    amount: schema.fields.number({ default: 0 }),
    currency: schema.fields.string({ default: "CNY" }),
    eventId: schema.fields.string({ default: "" }),
    payMethod: schema.fields.string({ default: "cash" }),
    title: schema.fields.string({ default: "" })
  },
  indexes: {
    createdAt: {
      field: "createdAt"
    },
    planId: {
      field: "planId"
    }
  },
  compounds: {
    // date_location: {
    //   of: ['date', 'location'],
    // },
    planId_date: {
      of: ["planId", "date"]
    }
  }
});
var schema_default = schema({
  version: 22,
  collections: {
    items,
    entries,
    weather,
    airplane,
    events,
    expense
  }
});
export {
  schema_default as default
};
